import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateMaxVideoChannels = (
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): void => {
  console.log(`Video channels: ${info.videoTracks.length}`);

  trackEventProperties[TrackEventProp.VIDEO_UPLOAD_VIDEO_CHANNELS] = info.videoTracks.length;

  if (info.videoTracks.length > 1) {
    addError(VALIDATIONS.MAX_VIDEO_CHANNELS);
  }
};

export default validateMaxVideoChannels;
